export default __webpack_public_path__ + "static/media/NanumSquare_acR.4e7e79f4.ttf";